import { createActionCreators } from '@nextiva/analytics-lib';
import * as DP from '../dataProvider';

var _a = createActionCreators('featureToggling'),
    // createSimpleAsyncAction,
createAsyncAction = _a.createAsyncAction,
    createAction = _a.createAction;

export var fetchAvailableFeatures = createAsyncAction('FETCH_AVAILABLE_FEATURES', function (featuresFromLocalStore) {
  return {
    payload: DP.fetchAvailableFeatures(),
    meta: {
      featuresFromLocalStore: featuresFromLocalStore
    }
  };
});
export var enableFeature = createAction('ENABLE_FEATURE');
export var disableFeature = createAction('DISABLE_FEATURE');